import { render, staticRenderFns } from "./unAdd.vue?vue&type=template&id=54dedf1a&scoped=true"
import script from "./unAdd.vue?vue&type=script&lang=js"
export * from "./unAdd.vue?vue&type=script&lang=js"
import style0 from "./unAdd.vue?vue&type=style&index=0&id=54dedf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dedf1a",
  null
  
)

export default component.exports